<template>
  <div class="ui middle center aligned grid" id="form">
    <div class="ui two cards">
      <div class="card">
        <div class="content">
          <div class="header">私密代理状态</div>
          <div class="description">
            <p>运行状态：{{ status.running }}</p>
            <p>线程数量：{{ status.threads }}</p>
            <p>运行次数：{{ status.count }}</p>
            <p>剩余数量：{{ status.total }}</p>
            <p>开始时间：{{ status.startTime }}</p>
            <p v-if="status.endTime">结束时间：{{ status.endTime }}</p>
            <button class="ui negative button" @click.prevent="cancel">取消</button>
            <button class="ui primary button" @click.prevent="load">刷新</button>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="content">
          <div class="header">搜索</div>
          <div class="description">
            <form class="ui form">
              <div class="inline field">
                <label>Client Id</label>
                <input type="text" name="clientId" v-model="form.clientId">
              </div>
              <div class="inline field">
                <label>Client Key</label>
                <input type="text" name="clientKey" v-model="form.clientKey">
              </div>
              <div class="inline field">
                <label>运行次数</label>
                <input type="number" name="count" v-model="form.count">
              </div>
              <div class="inline field">
                <label>线程数量</label>
                <input type="number" name="threads" v-model="form.threads">
              </div>
              <button class="ui primary button" @click.prevent="submit">运行</button>
            </form>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="content">
          <div class="header">隧道代理状态</div>
          <div class="description">
            <p>运行状态：{{ status2.running }}</p>
            <p>运行次数：{{ status2.count }}</p>
            <p>开始时间：{{ status2.startTime }}</p>
            <button class="ui button" :class="{negative: status2.running, primary: !status2.running}"
                    @click.prevent="updateStatus(!status2.running)">{{ status2.running? '暂停' : '工作' }}</button>
            <button class="ui primary button" @click.prevent="load2">刷新</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Search',
  data() {
    return {
      id: 0,
      status: {
        running: false,
        count: 0,
        threads: 0,
        total: 0,
        startTime: '',
        endTime: '',
      },
      status2: {
        running: false,
        count: 0,
        threads: 0,
        total: 0,
        startTime: ''
      },
      form: {
        clientId: '',
        clientKey: '',
        count: 1000,
        threads: 1,
      },
    }
  },
  mounted() {
    this.form.clientId = localStorage.getItem('clientId') || ''
    this.form.clientKey = localStorage.getItem('clientKey') || ''
    this.refresh()
    this.id = setInterval(() => this.refresh(), 30000)
  },
  destroyed() {
    clearInterval(this.id)
  },
  methods: {
    refresh() {
      this.load()
      this.load2()
    },
    load() {
      axios.get('/search?id=1').then(({data}) => {
        this.status = data
      })
    },
    load2() {
      axios.get('/search?id=2').then(({data}) => {
        this.status2 = data
      })
    },
    cancel() {
      axios.delete('/search?id=1').then(() => {
        this.$toasted.info('任务取消')
      })
    },
    updateStatus(running) {
      axios.post('/search/status?id=2&running=' + running).then(() => {
        this.load2()
      })
    },
    submit() {
      localStorage.setItem('clientId', this.form.clientId)
      localStorage.setItem('clientKey', this.form.clientKey)
      axios.post('/search', this.form).then(({data}) => {
        this.load()
        if (!data) {
          this.$toasted.error('任务未启动')
        }
      }, (error) => {
        this.$toasted.error(error.message)
      })
    }
  }
}
</script>

<style scoped>
#form {
  margin-top: 100px;
}
</style>
